import React from "react";
import { Outlet } from "react-router-dom";
import ProtectedRoute from "@/features/auth/components/ProtectedRoute";
import MainLayout from "@/components/layout/MainLayout";
import { NotificationToasts } from "@/features/outpostforge/components/organisms/NotificationToasts";

const ProtectedLayout = ({ requiredPage }) => {
  return (
    <ProtectedRoute requiredPage={requiredPage}>
      <MainLayout>
        <Outlet />
        {/* AWS LCCS module toasts (network/permission + apply/cancel outcomes) */}
        <NotificationToasts />
      </MainLayout>
    </ProtectedRoute>
  );
};

export default ProtectedLayout;
